import { GameVisuals } from "../../../gql/graphql";
import { getRowStatus } from "../statuses";
import { Cell } from "./Cell";
import { Row } from "./Row";

type CompletedRowProps = {
  guess: string;
  solution: string;
  theme: GameVisuals;
};
export const CompletedRow = ({ guess, solution, theme }: CompletedRowProps) => {
  const splittedGuess = guess.split("");
  const status = getRowStatus(solution, guess);

  return (
    <Row>
      {splittedGuess.map((letter, i) => (
        <Cell key={i} letter={letter} status={status[i]} theme={theme}/>
      ))}
    </Row>
  );
};
